/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, Tc, SCS, doT, scsHeader) {
	'use strict';

	var RESPONSE_TIMEOUT = 5000;
	var DEFAULT_LANG = 'de';
	var CACHING_TIME = 60000;

	/**
	 * TileOrderStatus module implementation.
	 *
	 * @author Nikola Tica
	 * @namespace Tc.Module
	 * @class TileOrderStatus
	 * @extends Tc.Module
	 */
	Tc.Module.TileOrderStatus = Tc.Module.extend({
		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @memberof TileOrderStatus
		 * @param {Function} callback function
		 * @returns void
		 */
		on: function (callback) {
			var mod = this,
				lang = (SCS && SCS.portal && SCS.portal.lang) ? SCS.portal.lang : DEFAULT_LANG;

			mod.showLoadingScreen();
			mod.hideErrorScreen();
			mod.hideNoOrderMsg();
			mod.hideOrders();

			mod.url = SCS.Url.updateQueryStringParameter(mod.$ctx.data('mod-url'), 'lang', lang);

			require('lib/personalization/profile').getProfile().then(function(profile) {
				var user = profile.getUser();
				var cachedItemId = (user ? user.getId() : 'anonymous') + '-cached-orders';

				var data = SCS.utils.cache.getCacheData(cachedItemId);
				if (data) {
					mod.processData(data);
				} else {
					$.ajax({
						timeout: RESPONSE_TIMEOUT,
						url : mod.url,
						dataType: 'json',
						success : function (data) {
							SCS.utils.cache.cacheData(data, cachedItemId, CACHING_TIME);
							mod.processData(data);
						},
						error : function () {
							mod.hideLoadingScreen();
							mod.showErrorScreen();
						}
					});
				}
			});

			callback();
		},
		/**
		 * This function shows loading display.
		 *
		 * @method showLoadingScreen
		 * @memberof TileOrderStatus
		 * @returns void
		 */
		showLoadingScreen: function () {
			var mod = this;
			mod.$ctx.find('.loading-message-section').removeClass('is-hidden');
		},
		/**
		 * This function hides loading display.
		 *
		 * @method hideLoadingScreen
		 * @memberof TileOrderStatus
		 * @returns void
		 */
		hideLoadingScreen: function () {
			var mod = this;
			mod.$ctx.find('.loading-message-section').addClass('is-hidden');
		},
		/**
		 * This function shows error screen.
		 *
		 * @method showErrorScreen
		 * @memberof TileOrderStatus
		 * @returns void
		 */
		showErrorScreen: function () {
			var mod = this;
			mod.$ctx.find('.error-message-section').removeClass('is-hidden');
		},
		/**
		 * This function hides error screen.
		 *
		 * @method hideErrorScreen
		 * @memberof TileOrderStatus
		 * @returns void
		 */
		hideErrorScreen: function () {
			var mod = this;
			mod.$ctx.find('.error-message-section').addClass('is-hidden');
		},
		/**
		 * This function shows no order message.
		 *
		 * @method showNoOrderMsg
		 * @memberof TileOrderStatus
		 * @returns void
		 */
		showNoOrderMsg: function () {
			var mod = this;
			mod.$ctx.find('.no-order-section').removeClass('is-hidden');
		},
		/**
		 * This function hides no order message.
		 *
		 * @method hideNoOrderMsg
		 * @memberof TileOrderStatus
		 * @returns void
		 */
		hideNoOrderMsg: function () {
			var mod = this;
			mod.$ctx.find('.no-order-section').addClass('is-hidden');
		},
		/**
		 * This function shows the order section.
		 *
		 * @method showOrders
		 * @memberof TileOrderStatus
		 * @returns void
		 */
		showOrders: function () {
			var mod = this;
			mod.$ctx.find('.results-section').removeClass('is-hidden');
		},
		/**
		 * This function hides the order section.
		 *
		 * @method hideOrders
		 * @memberof TileOrderStatus
		 * @returns void
		 */
		hideOrders: function () {
			var mod = this;
			mod.$ctx.find('.results-section').addClass('is-hidden');
			mod.$ctx.find('.result-container').empty();
		},
		/**
		 * This function creates HTML fron data retrieved from the MUST.
		 *
		 * @method renderData
		 * @memberof TileOrderStatus
		 * @param {Array} data Array of objects that contains orders information.
		 * @returns void
		 */
		renderData: function (data) {
			var mod = this;
			var $ordersTemplate = mod.$ctx.find('script.tmpl-order-status'),
				tmplItem = doT.template($ordersTemplate.html());
			var renderData = data.map(function (item) {
				return {
					statusIconColorClass: mod.getStatusColorClass(item.status),
					statusIcon: mod.getStatusIcon(item.status),
					title: item.title || '',
					dateCreated: SCS.utils.date.format(SCS.utils.date.fromString(item.dateCreated)) || '',
					referenceId: item.referenceId || '',
					orderFor: item.orderFor || '',
					detailLink: item.detailLink || 'javascript' + String.fromCharCode(58) + 'void(0);'
				};
			});
			var $html = $(tmplItem({orders: renderData}));
			mod.$ctx.find('.result-container').append($html);
		},
		/**
		 * This function returns SDX icon used to represent given status.
		 *
		 * @method getStatusIcon
		 * @memberof TileOrderStatus
		 * @param {String} status Order status. Expected values: NONE, CLOSED,
		 * WAITING, IN_PROGRESS, OPEN_REVISABLE, NEEDS_ATTENTION
		 * @returns {String} Status icon
		 */
		getStatusIcon: function (status) {
			var icon;
			switch (status) {
				case 'CLOSED':
					icon = 'icon-012-check-mark-circle';
					break;
				case 'OPEN_REVISABLE':
					icon = 'icon-026-exclamation-mark-circle';
					break;
				case 'NEEDS_ATTENTION':
					icon = 'icon-026-exclamation-mark-circle';
					break;
				default:
					icon = 'icon-021-clock';
			}
			return icon;
		},
		/**
		 * This function returns SDX icon collor class used to represent given
		 * status.
		 *
		 * @method getStatusColorClass
		 * @memberof TileOrderStatus
		 * @param {String} status Order status. Expected values: NONE, CLOSED,
		 * WAITING, IN_PROGRESS, OPEN_REVISABLE, NEEDS_ATTENTION
		 * @returns {String} Status icon color class
		 */
		getStatusColorClass: function (status) {
			var colorClass;
			switch (status) {
				case 'CLOSED':
					colorClass = 'int-green';
					break;
				case 'OPEN_REVISABLE':
					colorClass = 'int-red';
					break;
				case 'NEEDS_ATTENTION':
					colorClass = 'int-red';
					break;
				default:
					colorClass = 'gray-mid';
			}
			return colorClass;
		},
		/**
		 * This function displays data or no orders message.
		 *
		 * @method processData
		 * @memberof TileOrderStatus
		 * @param {Array} data Array of objects that contains orders information.
		 * @returns void
		 */
		processData: function (data) {
			var mod = this;
			if(!data.length) {
				mod.hideLoadingScreen();
				mod.showNoOrderMsg();
			} else {
				mod.renderData(data);
				mod.hideLoadingScreen();
				mod.showOrders();
			}
		}

	});
})(window.Tc.$, window.Tc, window.SCS, window.doT, window.scsHeader);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TileOrderStatus.js
// module id = 194
// module chunks = 0